import { render, staticRenderFns } from "./newInvitation.vue?vue&type=template&id=400a5efb&scoped=true&"
import script from "./newInvitation.vue?vue&type=script&lang=js&"
export * from "./newInvitation.vue?vue&type=script&lang=js&"
import style0 from "./newInvitation.vue?vue&type=style&index=0&id=400a5efb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "400a5efb",
  null
  
)

export default component.exports